import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

const styles: ComponentStylesProps<boolean> = {
  employerBlockKey: {
    textTransform: 'uppercase',
    color: colors.neutral[500],
    fontWeight: 700,
    fontSize: '1.4rem',
    lineHeight: '2rem',
    letterSpacing: '0.02rem',
    margin: 0,
    marginBottom: '2.5rem',
  },
  employerBlockValue: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    margin: 0,
    wordBreak: 'break-word',
  },
  employerWrapper: (isGroupAdmin) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 11rem',
    columnGap: '2rem',
    alignItems: 'center',
    borderRadius: '0.6rem',
    backgroundColor: isGroupAdmin ? colors.blue[100] : colors.neutral[100],
    border: isGroupAdmin && `0.2rem solid ${colors.blue[600]}`,
    padding: '2.4rem 4rem',
    '&:not(:last-child)': {
      marginBottom: '3rem',
    },
  }),
  employerBlock: {
    display: 'grid',
    gridTemplateColumns: '1fr 1.5fr 1fr 1fr 1.5fr',
    columnGap: '2%',
    rowGap: '4rem',
    '@media(max-width: 820px)': {
      gridTemplateColumns: 'repeat(auto-fit, minmax(12rem, 1fr))',
    },
  },
  statusValue: {
    color: colors.neutral[800],
    marginLeft: '1rem',
  },
  statusActionBtn: {
    textTransform: 'uppercase',
    padding: 0,
  },
  editEmployerForm: {
    border: `2px solid ${colors.blue[300]}`,
    marginBottom: '3rem',
  },
  actionBtn: {
    textTransform: 'uppercase',
    '&:not(:last-child)': {
      marginBottom: '2rem',
    },
  },
  groupAdminTag: {
    color: colors.blue[600],
    paddingLeft: '0.6rem',
    fontSize: '1.4rem',
    fontWeight: 700,
    textTransform: 'uppercase',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
